(function () {

  /*
   * =========================================================
   * MADSPEED7 PRODUCT QUICK VIEW
   * Collection page
   * =========================================================
   */


  function createQuickViewModal() {

    let overlay =
      document.querySelector('.madspeed7-qv-overlay');

    if (overlay) {
      return overlay;
    }


    overlay = document.createElement('div');

    overlay.className =
      'madspeed7-qv-overlay';

    overlay.style.display = 'none';


    overlay.innerHTML = `
  <div
    class="madspeed7-qv-modal"
    role="dialog"
    aria-modal="true"
  >

    <button
      type="button"
      class="madspeed7-qv-close"
      aria-label="Close quick view"
    >
      &times;
    </button>

    <div class="madspeed7-qv-scroll">

      <div class="madspeed7-qv-image-wrapper">

        <div class="madspeed7-qv-gallery">

          <div class="madspeed7-qv-main-image-wrapper">

            <img
              class="madspeed7-qv-image"
              src=""
              alt=""
            >

          </div>


          <div class="madspeed7-qv-thumbnails"></div>

        </div>

      </div>


      <div class="madspeed7-qv-details">

        <h2 class="madspeed7-qv-title"></h2>

        <div class="madspeed7-qv-price"></div>

        <div class="madspeed7-qv-description"></div>

        <a
          class="madspeed7-qv-product-link"
          href="#"
        >
          View product
        </a>

      </div>

    </div>

  </div>
`;


    document.body.appendChild(overlay);


    /*
     * Close button
     */

    const closeButton =
      overlay.querySelector(
        '.madspeed7-qv-close'
      );


    closeButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        closeQuickView(overlay);

      }
    );


    /*
     * Close when clicking outside modal
     */

    overlay.addEventListener(
      'click',
      function (event) {

        if (
          event.target === overlay
        ) {

          closeQuickView(overlay);

        }

      }
    );


    return overlay;
  }


  /*
   * ---------------------------------------------------------
   * Close Quick View
   * ---------------------------------------------------------
   */

  function closeQuickView(overlay) {

    overlay.style.display =
      'none';

    document.body.style.overflow =
      '';

  }


  /*
   * ---------------------------------------------------------
   * Get product handle
   * ---------------------------------------------------------
   */

  function getProductHandle(card) {

    const productLink =
      card.querySelector(
        'a[href*="/products/"]'
      );


    if (!productLink) {
      return null;
    }


    const href =
      productLink.getAttribute('href');


    if (!href) {
      return null;
    }


    const match =
      href.match(
        /\/products\/([^?#/]+)/
      );


    return match
      ? match[1]
      : null;
  }


  /*
   * ---------------------------------------------------------
   * Open Quick View
   * ---------------------------------------------------------
   */

  async function openQuickView(card) {

    const handle =
      getProductHandle(card);


    if (!handle) {

      console.error(
        'MADSPEED7 Quick View: Product handle not found.'
      );

      return;

    }


    const overlay =
      createQuickViewModal();


    const image =
      overlay.querySelector(
        '.madspeed7-qv-image'
      );


    const title =
      overlay.querySelector(
        '.madspeed7-qv-title'
      );


    const price =
      overlay.querySelector(
        '.madspeed7-qv-price'
      );


    const description =
      overlay.querySelector(
        '.madspeed7-qv-description'
      );


    const productLink =
      overlay.querySelector(
        '.madspeed7-qv-product-link'
      );


    const thumbnails =
      overlay.querySelector(
        '.madspeed7-qv-thumbnails'
      );


    /*
     * Open immediately
     */

    overlay.style.display =
      'flex';

    document.body.style.overflow =
      'hidden';


    /*
     * Loading state
     */

    title.textContent =
      'Loading...';

    price.textContent =
      '';

    description.textContent =
      'Loading product information...';

    image.removeAttribute(
      'src'
    );

    thumbnails.innerHTML =
      '';

    productLink.href =
      '/products/' + handle;


    try {

      /*
       * Get product data
       */

      const response =
        await fetch(
          '/products/' +
          handle +
          '.js'
        );


      if (!response.ok) {

        throw new Error(
          'Product request failed: ' +
          response.status
        );

      }


      const product =
        await response.json();


      /*
       * -----------------------------------------------------
       * Product title
       * -----------------------------------------------------
       */

      title.textContent =
        product.title || '';


      /*
       * -----------------------------------------------------
       * Product price
       * -----------------------------------------------------
       */

      if (
        typeof product.price ===
        'number'
      ) {

        price.textContent =
          new Intl.NumberFormat(
            'en-GB',
            {
              style: 'currency',
              currency: 'GBP'
            }
          ).format(
            product.price / 100
          );

      }


      /*
       * -----------------------------------------------------
       * Product description
       * -----------------------------------------------------
       */

      description.innerHTML =
        product.description || '';


      /*
       * -----------------------------------------------------
       * Product images
       * -----------------------------------------------------
       */

      const images =
        Array.isArray(product.images)
          ? product.images
          : [];


      /*
       * Fallback to featured image
       */

      if (
        !images.length &&
        product.featured_image
      ) {

        images.push(
          product.featured_image
        );

      }


      let currentImageIndex =
        0;


      /*
       * Display selected image
       */

      function showImage(index) {

        if (!images.length) {
          return;
        }


        currentImageIndex =
          (index + images.length) %
          images.length;


        image.src =
          images[currentImageIndex];

        image.alt =
          product.title || '';


        /*
         * Highlight active thumbnail
         */

        const thumbnailButtons =
          thumbnails.querySelectorAll(
            '.madspeed7-qv-thumbnail'
          );


        thumbnailButtons.forEach(
          function (thumbnail, thumbnailIndex) {

            thumbnail.classList.toggle(
              'is-active',
              thumbnailIndex ===
                currentImageIndex
            );

          }
        );


      }


      /*
       * -----------------------------------------------------
       * Create thumbnails
       * -----------------------------------------------------
       */

      images.forEach(
        function (imageUrl, index) {

          const thumbnailButton =
            document.createElement(
              'button'
            );


          thumbnailButton.type =
            'button';


          thumbnailButton.className =
            'madspeed7-qv-thumbnail';


          thumbnailButton.setAttribute(
            'aria-label',
            'View product image ' +
              (index + 1)
          );


          const thumbnailImage =
            document.createElement(
              'img'
            );


          thumbnailImage.src =
            imageUrl;


          thumbnailImage.alt =
            product.title || '';


          thumbnailButton.appendChild(
            thumbnailImage
          );


          thumbnailButton.addEventListener(
            'click',
            function () {

              showImage(index);

            }
          );


          thumbnails.appendChild(
            thumbnailButton
          );

        }
      );


      /*
       * Show first image
       */

      showImage(0);


    } catch (error) {

      console.error(
        'MADSPEED7 Quick View error:',
        error
      );


      title.textContent =
        'Unable to load product';


      price.textContent =
        '';


      description.textContent =
        'Please use the button below to view the product.';

    }

  }


  /*
 * ---------------------------------------------------------
 * Create Quick View buttons
 * ---------------------------------------------------------
 */

function createQuickViewButtons() {

  const cards = document.querySelectorAll(
    '.card-wrapper.product-card-wrapper'
  );

  cards.forEach(function (card) {

    /*
 * Find the actual product image area
 */
const imageArea = card.querySelector(
  '.card__inner'
);

if (!imageArea) {
  return;
}

/*
 * Don't create duplicate buttons
 */
if (
  imageArea.querySelector(
    ':scope > .madspeed7-product-quick-view'
  )
) {
  return;
}

    /*
     * Find product link
     */
    const productLink = card.querySelector(
      'a[href*="/products/"]'
    );

    if (!productLink) {
      return;
    }

    /*
     * Create Quick View button
     */
    const button = document.createElement(
      'button'
    );

    button.type = 'button';

    button.className =
      'madspeed7-product-quick-view';

    /*
     * Desktop text
     */
    const desktopText =
      document.createElement('span');

    desktopText.className =
      'madspeed7-qv-desktop-text';

    desktopText.textContent =
      'Quick view';

    button.appendChild(desktopText);

    /*
     * Mobile eye icon
     */
    const mobileIcon =
      document.createElement('span');

    mobileIcon.className =
      'madspeed7-qv-mobile-icon';

    mobileIcon.innerHTML = `
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="12"
          cy="12"
          r="2.5"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
        />
      </svg>
    `;

    button.appendChild(mobileIcon);

    /*
     * Store product card reference
     */
    button._madspeed7Card = card;

    /*
 * Put the button INSIDE the image area.
 * This allows CSS to centre it over the product image.
 */
imageArea.appendChild(button);

    /*
     * Direct button click handler
     */
    button.addEventListener(
  'click',
  function (event) {

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openQuickView(card);

  },
  true
);

card.addEventListener(
  'click',
  function (event) {

    if (
      event.target.closest(
        '.madspeed7-product-quick-view'
      )
    ) {
      return;
    }

    const href = productLink.getAttribute('href');

    if (!href) {
      return;
    }

    window.location.href = href;

  },
  true
);

  });

}


/*
 * ---------------------------------------------------------
 * Initial load
 * ---------------------------------------------------------
 */

document.addEventListener(
  'DOMContentLoaded',
  function () {
    createQuickViewButtons();
  }
);


window.addEventListener(
  'load',
  function () {
    createQuickViewButtons();
  }
);


/*
 * ---------------------------------------------------------
 * Watch for Dawn dynamic updates
 * ---------------------------------------------------------
 */

const observer =
  new MutationObserver(
    function () {
      createQuickViewButtons();
    }
  );


observer.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);


})();